import { TUTORIAL_IDS } from "@/shared";
import { useVehiclesTableStore } from "@/stores/useTableStore";

import { STEP_GROUP, TUTORIAL_BUTTON_TYPE } from "../../types";
import useTutorialMode from "../useTutorialMode";

const useApplyScheduleActions = (
  isVehiclesPage: boolean,
  handleTutorialCompletion: (stepGroup: STEP_GROUP) => Promise<void>
) => {
  const {
    stepGroup,
    stepIndex,
    handleTutorialStepIndexChange,
    setIsMobileDrawerOpen,
    handleClearVehiclesTableHead,
    setTutorialDetails
  } = useTutorialMode();

  const setSelectedRows = useVehiclesTableStore(state => state.setSelectedRows);

  const resetVehiclesTableDetails = useVehiclesTableStore(
    state => state.resetTableDetails
  );

  const handleDesktopPreviousButton = () => {
    switch (stepIndex) {
      case 2:
        handleClearVehiclesTableHead();
        return handleTutorialStepIndexChange(stepIndex - 1);
      case 3:
        document
          .getElementById(TUTORIAL_IDS.SchedulesMainDialogCloseButton)
          ?.click();
        return handleTutorialStepIndexChange(stepIndex - 1);
      case 5:
        resetVehiclesTableDetails();
        document.getElementById(TUTORIAL_IDS.SchedulesDialogButton)?.click();
        handleTutorialStepIndexChange(stepIndex - 1);
        break;
      default:
        handleTutorialStepIndexChange(stepIndex - 1);
        break;
    }
  };

  const handleDesktopNextButton = () => {
    const nextStepIndex = isVehiclesPage ? 2 : 1;
    switch (stepIndex) {
      case 0:
        return handleTutorialStepIndexChange(stepIndex + nextStepIndex);
      case 4:
        document
          .getElementById(TUTORIAL_IDS.SchedulesMainDialogCloseButton)
          ?.click();
        document.getElementById(TUTORIAL_IDS.Row0)?.click();
        setTutorialDetails({
          isTutorialOpen: false,
          stepIndex: stepIndex + 1,
          stepGroup: stepGroup,
          isTutorialActive: true
        });
        break;
      case 5:
        handleTutorialCompletion(STEP_GROUP.TutorialApplySchedule);
        break;
      default:
        handleTutorialStepIndexChange(stepIndex + 1);
        break;
    }
  };

  const handleMobilePreviousButton = () => {
    switch (stepIndex) {
      case 1:
        setIsMobileDrawerOpen(false);
        break;
      case 3:
        handleClearVehiclesTableHead();
        break;
      case 4:
        setSelectedRows([]);
        break;
      case 5:
        document
          .getElementById(TUTORIAL_IDS.SchedulesMainDialogCloseButton)
          ?.click();
        break;
      case 7:
        document.getElementById(TUTORIAL_IDS.SchedulesDialogButton)?.click();
        break;
      default:
        break;
    }
    handleTutorialStepIndexChange(stepIndex - 1);
  };

  const handleMobileNextButton = () => {
    switch (stepIndex) {
      case 6:
        document
          .getElementById(TUTORIAL_IDS.SchedulesMainDialogCloseButton)
          ?.click();
        handleTutorialStepIndexChange(stepIndex + 1);
        break;
      case 7:
        handleTutorialCompletion(STEP_GROUP.TutorialApplySchedule);
        break;
      default:
        handleTutorialStepIndexChange(stepIndex + 1);
        break;
    }
  };

  const applyScheduleDesktopButtonActions = (
    buttonType: TUTORIAL_BUTTON_TYPE
  ) => {
    buttonType === TUTORIAL_BUTTON_TYPE.Previous
      ? handleDesktopPreviousButton()
      : handleDesktopNextButton();
  };

  const applyScheduleMobileButtonActions = (
    buttonType: TUTORIAL_BUTTON_TYPE
  ) => {
    buttonType === TUTORIAL_BUTTON_TYPE.Previous
      ? handleMobilePreviousButton()
      : handleMobileNextButton();
  };

  return {
    applyScheduleDesktopButtonActions,
    applyScheduleMobileButtonActions
  };
};

export default useApplyScheduleActions;
